import { createStore, compose } from "redux";
import rootReducers from "./reducers";

const composeEnhancers =
  (window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] as typeof compose) || compose;

const store = createStore(rootReducers, composeEnhancers());

export default store;
